import React, { useContext } from 'react'
import { IoArrowForwardOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { Images } from "constants";
import { UserContext } from 'context';

const UpgradeBar = ({ remainingDays, warningDetails }) => {
    const isFreePlan = warningDetails?.subscription_data?.plan_type === "Free Plan";

    const { setSubscriptionDetails } = useContext(UserContext)

    const navigate = useNavigate()
    return (
        <>
            <div className='__subscr_planUp_bx'>
                {remainingDays != "" && <img src={Images.WARN_ICON.default} alt="" />}
                <div>
                    {remainingDays > 0 && (
                        <div>
                            <h6>
                                You have Transport 360{" "}
                                <span style={{ color: "#06f" }}>
                                    {warningDetails?.subscription_data?.plan_type}
                                </span>
                                {!isFreePlan && (
                                    <>
                                        {" "} Subscription Ends in {remainingDays}{" "}
                                        {remainingDays === 1 ? "Day" : "Days"}
                                    </>
                                )}
                            </h6>

                        </div>
                        // <p style={{fontWeight:500, fontSize:"16px",color:"#000"}}>

                        // </p>
                    )}

                    {(remainingDays == 0 && remainingDays != "") && (
                        <p style={{ color: "red" }}>
                            Your <strong>{warningDetails?.subscription_data?.plan_type}</strong> Subscription Has Expired!
                        </p>
                    )}

                </div>
                {remainingDays != "" && <button
                    className={`anime-btn __upGrd_btn ${remainingDays > 0 ? "upgrade-btn" : "buy-btn"
                        }`}
                    onClick={() => {
                        setSubscriptionDetails(warningDetails?.subscription_data)
                        navigate(remainingDays > 0 ? "/subscription" : "/subscription/plan_detail")
                    }}
                >
                    {remainingDays > 0 ? "Upgrade Plan" : "Buy Plan"}
                    <IoArrowForwardOutline />
                </button>}
            </div>
        </>
    )
}

export default UpgradeBar